import { render, staticRenderFns } from "./CompanyMenuFoodOrderCard.vue?vue&type=template&id=82454b9a&scoped=true"
import script from "./CompanyMenuFoodOrderCard.vue?vue&type=script&lang=js"
export * from "./CompanyMenuFoodOrderCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyMenuFoodOrderCard.vue?vue&type=style&index=0&id=82454b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82454b9a",
  null
  
)

export default component.exports